import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Landmark } from "lucide-react";
import {
  DateField,
  EditActions,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "../common";

const Field = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="flex flex-col gap-1">
    <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
    <div className="text-sm">{children}</div>
  </div>
);

export const DepartmentShow = () => (
  <Show actions={<EditActions />}>
    <div className="max-w-3xl mx-auto">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <Landmark className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Department Details</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <SimpleShowLayout className="grid grid-cols-1 md:grid-cols-2 gap-6 [&>*]:m-0">
            <Field label="Department Name">
              <TextField source="name" />
            </Field>
            <Field label="Department Code">
              <TextField source="code" />
            </Field>
            <Field label="Department Head">
              <ReferenceField source="head_employee_id" reference="employees">
                <TextField source="name" />
              </ReferenceField>
            </Field>
            <Field label="Created">
              <DateField source="created_at" showTime />
            </Field>
          </SimpleShowLayout>
        </CardContent>
      </Card>
    </div>
  </Show>
);
